import React from 'react';
import { Button, ButtonGroup } from 'ui';

const Form = ({
  updateQuestion,
  question,
  expert,
  loading,
  onSubmit,
  onClose,
  i18n,
}) => (
  <div className="Modal-container">
    <div className="Modal-header">{i18n.heading}</div>
    <div className="ExpertForm p-16">
      <textarea
        ref={n => n && n.focus()}
        className="ExpertForm-message p-0"
        placeholder={i18n.placeholder}
        value={question}
        onChange={e => updateQuestion(e.target.value)}
      />
      <ButtonGroup alignEnd>
        <button
          type="button"
          onClick={onClose}
          className="u-linkBtn u-linkBtn--dark"
        >
          {i18n.cancel}
        </button>
        <Button
          onClick={onSubmit}
          loading={loading}
          disabled={!question.trim()}
          tall
          customColor
        >
          {i18n.action} {expert.name}
        </Button>
      </ButtonGroup>
    </div>
  </div>
);

export default Form;
